<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>

  <form @submit.prevent="store" class="form-content">
    <div class="form-content-inner">
      <div class="form-content-list">
        <control
          type="hidden"
          v-model="programme.id"
          :hasError="!!errors.id"
          id="id"
        />

        <div class="form-col">
          <field
            :label="$t('programme.school')"
            class="w-full md:ml-2 mb-2 md:mb-0"
            :hasError="errors.school_id"
          >
            <control
              :options="schoolList"
              :placeholder="$t('programme.placeholder.schoolselect')"
              v-model="programme.school_id"
              id="school_id"
              :hasError="!!errors.school_id"
              required="required"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('programme.branch')"
            class="w-full md:ml-2 mb-2 md:mb-0"
            :hasError="errors.branch_id"
          >
            <control
              :options="branchList"
              :placeholder="$t('programme.placeholder.branchselect')"
              v-model="programme.branch_id"
              id="branch_id"
              :hasError="!!errors.branch_id"
              required="required"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('programme.code')"
            class="w-full md:ml-2 mb-2 md:mb-0"
            :hasError="errors.code"
          >
            <control
              type="text"
              :placeholder="$t('programme.placeholder.code')"
              v-model="programme.code"
              :hasError="!!errors.code"
              id="code"
              required="required"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('programme.name')"
            class="w-full md:ml-2 mb-2 md:mb-0"
            :hasError="errors.name"
          >
            <control
              type="text"
              :placeholder="$t('programme.placeholder.name')"
              v-model="programme.name"
              :hasError="!!errors.name"
              id="name"
              required="required"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            class="w-full md:ml-2 mb-2 md:mb-0"
            :label="$t('programme.description')"
            help="Your question. Max 255 characters"
            :hasError="errors.remarks"
          >
            <control
              type="textarea"
              :placeholder="$t('programme.description')"
              v-model="programme.description"
              id="remarks"
              :hasError="!!errors.remarks"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('programme.startdate')"
            class="w-full md:w-1/2 md:mr-2"
            :hasError="errors.programme_year_id"
          >
            <datepicker
              v-model="programme.start_date"
              :enableTimePicker="false"
              :auto-apply="true"
            ></datepicker>
          </field>

          <field
            :label="$t('programme.enddate')"
            class="w-full md:w-1/2 md:ml-2"
            :hasError="errors.level_id"
          >
            <datepicker
              v-model="programme.end_date"
              :enableTimePicker="false"
              :auto-apply="true"
            ></datepicker>
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('programme.file_name')"
            class="w-full md:ml-2 mb-2 md:mb-0"
            help="* support only pdf format"
            :hasError="errors.file_name"
          >
            <input
              type="file"
              accept="application/pdf"
              v-on:change="onFileChange"
              class="form-control-file"
              id="my-file"
            />
          </field>
        </div>

        <div v-if="image.name" class="file-meta">
          <p><strong>File Name:</strong> {{ image.name }}</p>
          <p>
            <strong>File Size:</strong> {{ (image.size / 1024).toFixed(2) }} KB
          </p>
        </div>
      </div>

      <!-- Preview Section -->
      <div class="preview-content">
        <div class="outer-prev">
          <h2 class="preview-title">File Preview</h2>
          <center><p v-if="!previewFile">No Preview</p></center>
          <vue-pdf-embed
            :source="previewFile"
            style="width: 100%; height: 100%; min-height: 500px"
          />
        </div>
      </div>

      <div
        class="buttons-submit transition-colors duration-1000"
        :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
      >
        <jb-buttons class="buttons-action-submit">
          <jb-button
            type="submit"
            color="info"
            :icon="mdiCheckBold"
            :label="$t('finance.button.btnSubmit')"
            class="form-submit-btn"
          />
          <jb-button
            type="button"
            color="info"
            outline
            :label="$t('finance.button.btnReset')"
            class="form-noicon-btn btn-reset"
            @click="reset()"
          />
        </jb-buttons>
      </div>
    </div>
  </form>

  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { ref, reactive, onMounted, watch, watchEffect } from "vue";
import axios from "axios";
import { mdiBallot, mdiCheckBold } from "@mdi/js";
import Control from "@/components/Control";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import JbButton from "@/components/JbButton";
import JbButtons from "@/components/JbButtons";
import Field from "@/components/Field";
import { useToast } from "vue-toastification";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VuePdfEmbed from "vue-pdf-embed";

export default {
  name: "ClassForm",
  components: {
    Field,
    Control,
    Loading,
    JbButton,
    Datepicker,
    JbButtons,
    VuePdfEmbed,
  },
  props: {
    showEdit: { type: Boolean, default: false },
    propObject: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propDepartment: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propYear: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propLevel: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  emits: ["close-modal", "submit", "reset-modal"],
  setup(props, { emit }) {
    const { t } = useToast();
    const titleStack = ref(["Admin", "Forms"]);
    const isLoading = ref(false);
    const toast = useToast();
    const router = useRouter();
    const errors = ref({});
    const str = useStore();
    const userlogin = localStorage.getItem("name");

    const schoolList = ref([]);
    const branchList = ref([]);
    const academicYearList = ref([]);
    const previewFile = ref(null); // For PDF preview
    const image = ref({ name: "", size: 0 });
    const MaxUploadLimit = ref(0);

    const programme = reactive({
      id: "",
      school_id: "",
      branch_id: "",
      academic_year_id: "",
      code: "",
      name: "",
      description: "",
      start_date: "",
      end_date: "",
      file: null,
      file_url: "",
      created_by: "",
      updated_by: "",
    });

    const reset = () => {
      programme.id = "";
      programme.school_id = "";
      programme.branch_id = "";
      programme.academic_year_id = "";
      programme.name = "";
      programme.code = "";
      programme.description = "";
      programme.start_date = "";
      programme.end_date = "";
      programme.file = null;
      programme.file_url = "";
      image.value = { name: "", size: 0 };
      if (previewFile.value) {
        URL.revokeObjectURL(previewFile.value);
        previewFile.value = null;
      }
      errors.value = {};
      const fileInput = document.getElementById("my-file");
      if (fileInput) fileInput.value = "";
      emit("reset-modal");
    };

    const store = async () => {
      isLoading.value = true;
      const url = props.showEdit ? `programme/${programme.id}` : "programme";
      const method = props.showEdit ? "PUT" : "POST";
      if (method === "POST") {
        programme.created_by = userlogin;
      } else {
        programme.updated_by = userlogin;
      }

      const jsonData = JSON.stringify(programme);
      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };

      await axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          if (response.data.success) {
            emit("reset-modal");
            emit("close-modal");
            toast.success(response.data.message);
            reset();
          } else {
            errors.value = response.data.messages;
            toast.error(response.data.message || "Validation error");
          }
          isLoading.value = false;
        })
        .catch((error) => {
          console.error(error);
          toast.error(error.response?.data?.message || error.message);
          errors.value = error.response?.data?.messages || {};
          isLoading.value = false;
        });
    };

    const getSchool = async () => {
      isLoading.value = true;
      await axios
        .get("school")
        .then((response) => {
          schoolList.value = response.data.data;
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || error.message);
          console.error(error);
          isLoading.value = false;
        });
    };

    const getBranch = async () => {
      isLoading.value = true;
      await axios
        .get("branch")
        .then((response) => {
          branchList.value = response.data.data;
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || error.message);
          console.error(error);
          isLoading.value = false;
        });
    };

    const getAcademicYear = async () => {
      isLoading.value = true;
      await axios
        .get("academicyear")
        .then((response) => {
          academicYearList.value = response.data.data;
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || error.message);
          console.error(error);
          isLoading.value = false;
        });
    };

    const getUploadLimitProgramme = async () => {
      await axios
        .get("/upload-limit-programme")
        .then((res) => {
          MaxUploadLimit.value = res.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const onFileChange = async (event) => {
      const file = event.target.files[0];
      if (file) {
        const maxLimitMB = parseInt(MaxUploadLimit.value ?? '0');
        if (maxLimitMB > 0 && file.size > maxLimitMB * 1024 * 1024) {
          toast.error(`File too big ( > ${maxLimitMB}MB)`);
          event.target.value = "";
          previewFile.value = null;
          image.value = { name: "", size: 0 };
          programme.file = null;
          programme.file_url = "";
          return;
        }

        if (file.type !== "application/pdf") {
          toast.error("Only PDF files are allowed");
          event.target.value = "";
          previewFile.value = null;
          image.value = { name: "", size: 0 };
          programme.file = null;
          programme.file_url = "";
          return;
        }

        if (previewFile.value) {
          URL.revokeObjectURL(previewFile.value);
        }
        previewFile.value = URL.createObjectURL(file);
        // programme.file = file;
        // programme.file_url = "";
        // image.value = {
        //   name: file.name,
        //   size: file.size,
        // };

        // Read file as base64
        const reader = new FileReader();
        reader.onload = (e) => {
          programme.file_name = e.target.result; // Store base64 string
          image.value = {
            name: file.name,
            size: file.size,
          };
        };
        reader.onerror = () => {
          toast.error("Failed to read file");
          previewFile.value = null;
          image.value = { name: "", size: 0 };
          programme.file_name = "";
        };
        reader.readAsDataURL(file);
      } else {
        if (previewFile.value) {
          URL.revokeObjectURL(previewFile.value);
        }
        previewFile.value = null;
        image.value = { name: "", size: 0 };
        programme.file_name = "";
        event.target.value = "";
      }
    };

    onMounted(() => {
      getSchool();
      getBranch();
      getAcademicYear();
      getUploadLimitProgramme();
    });

    watch(
      () => schoolList.value,
      (newVal) => {
        if (newVal?.length === 1) {
          programme.school_id = newVal[0].id;
        }
      }
    );

    watchEffect(() => {
      const newObject = props.propObject;
      Object.assign(programme, newObject);

      if (props.showEdit && newObject.file_url) {
        if (!previewFile.value || previewFile.value !== newObject.file_url) {
          previewFile.value = newObject.file_url;
          image.value = {
            name: newObject.file_name || "Existing File",
            size: newObject.file_size || 0,
          };
        }
      }

      // if (!props.showEdit && !programme.file) {
      //   programme.id = null;
      //   programme.school_id = null;
      //   programme.branch_id = null;
      //   programme.academic_year_id = null;
      //   programme.name = null;
      //   programme.code = null;
      //   programme.description = null;
      //   programme.start_date = null;
      //   programme.end_date = null;
      //   programme.file = null;
      //   programme.file_url = "";
      //   if (previewFile.value && !image.value.name) {
      //     URL.revokeObjectURL(previewFile.value);
      //     previewFile.value = null;
      //     image.value = { name: "", size: 0 };
      //   }
      // }
    });

    return {
      isLoading,
      titleStack,
      schoolList,
      branchList,
      academicYearList,
      mdiBallot,
      mdiCheckBold,
      router,
      getSchool,
      getBranch,
      getAcademicYear,
      programme,
      store,
      str,
      toast,
      userlogin,
      errors,
      reset,
      previewFile,
      image,
      onFileChange,
      MaxUploadLimit,
    };
  },
  methods: {
    clearForm() {
      this.programme = reactive({
        id: "",
        school_id: "",
        branch_id: "",
        academic_year_id: "",
        code: "",
        name: "",
        description: "",
        start_date: "",
        end_date: "",
        file: null,
        file_url: "",
        created_by: "",
        updated_by: "",
      });
      this.image = { name: "", size: 0 };
      this.previewFile = null;
    },
    onChange(programme, event) {
      if (event.target.value) {
        programme.school_id = event.target.value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content-container {
  display: flex;
  // flex-direction: column;
  // gap: 20px;
  // max-width: 1200px; /* Match parent modal width */
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  // min-height: 600px; /* Ensure minimum height for content */

  .form-content {
    width: 100%;


    .form-content-inner {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .form-content-list {
        width: 100%;

      .file-meta {
        margin-top: 10px;
        padding: 10px;
        background-color: #f1f5f9;
        border-radius: 4px;
        width: 100%;
        text-align: left;

        p {
          margin: 5px 0;
          color: #1f2937;
        }
      }
      }

      .preview-content {
        width: 100%;

        .outer-prev {
          .preview-title {
            font-size: 1.25rem;
            font-weight: 600;
            margin-bottom: 12px;
            color: #1f2937; /* Dark text for light theme */
            width: 100%;
            text-align: center;
          }
        }
      }
    }
  }

  .no-preview {
    color: #6b7280; /* Muted text for light theme */
    font-size: 1rem;
    text-align: center;
    width: 100%;
  }

  @media (min-width: 1024px) {
    .form-content {
      .form-content-inner {
        flex-direction: row;
      }
    }
  }
}
</style>
